import React from 'react';
export function Header() {
  return <header className="w-full border-b border-charcoal/10 bg-cream" data-id="element-143">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-144">
        <div className="flex items-baseline gap-3" data-id="element-145">
          <span className="font-heading text-lg md:text-xl font-semibold text-charcoal tracking-tight" data-id="element-146">
            Haar & Kopfhaut
          </span>
          <span className="hidden sm:inline text-charcoal/50 text-sm font-body italic" data-id="element-147">
            Alles für deine Haare
          </span>
        </div>
        <span className="text-[10px] font-ui tracking-widest uppercase text-charcoal/40 border border-charcoal/15 rounded px-2 py-0.5" data-id="element-148">
          Advertorial
        </span>
      </div>
    </header>;
}